import z, { any, object, string } from "zod"
import { phoneNumberValidator } from "@persian-tools/persian-tools"
import { FEMALE, MALE } from "constants/index"

export const userProfileRequestSchema = object({
  name: string()
    .optional()
    .nullable(),
  email: string()
    .min(1)
    .refine(value => {
      return String(value)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    }),
  phoneNumber: string()
    .optional()
    .nullable()
    .refine(value => !value || phoneNumberValidator(value)),
  birthday: string()
    .datetime({ offset: true })
    .or(string().max(0))
    .nullable()
    .transform(value => value || ""),
  gender: z.enum([FEMALE, MALE])
    .or(string().max(0))
    .nullable()
    .transform(value => value || ""),
  avatar: any().transform(value => value || new File([], ""))
})

export const updateAvatarSchema = object({
  avatar: any().transform(value => value || new File([], ""))
})
